module.exports = "<div class=\"imageProgress\"\r\n     *ngIf=\"loading\">\r\n    <app-image-progress></app-image-progress>\r\n</div>\r\n<div class=\"image_wrapper\" #wrapper>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/image/image.component.html
// module id = ./src/app/commons/image/image.component.html
// module chunks = main